<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsTicketTracker from '@/views/survey/ticket-management/AnalyticsTicketTracker.vue'
import CustomerCommunicationDrawer from '@/views/service-desk/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/service-desk/customer-communication/LogDrawer.vue'
import TicketFormDrawer from '@/views/service-desk/drawer/TicketFormDrawer.vue'
import TicketTable from '@/views/survey/ticket-management/TicketTable.vue'
import TicketDrawer from '@/views/survey/ticket-management/TicketDrawer.vue'

definePage({
  meta: {
    name: "Ticket Management",
    subject: "survey.menu",
    action: "ticket_management",
  },
})

const route = useRoute()

const ticketFilters = ref()

const { 
  data: filterOptions,
} = await useApi(createUrl('/survey/tickets/filters', {
  query: {
    type: 'service-desk',
  },
}))

const isTicketDrawerVisible = ref(false)
const ticketDrawerId = ref(null)
const refTicketTable = ref()
const communicationDrawerData = ref()

const showTicket = feedbackData => {
  ticketDrawerId.value = feedbackData?.id ?? feedbackData
  isTicketDrawerVisible.value = true
}

// check if ticket id is present in the route
if (route.query.ticket) {
  showTicket(Number(route.query.ticket))
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type, communicationFor='') => {
  communicationDrawerData.value = feedbackData
  communicationDrawerData.value.communicationFor = communicationFor
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const refTicketTracker =ref(null)

const refreshTicketData = async (closeDrawer = true) => {
  if (closeDrawer) isTicketDrawerVisible.value = false
  refTicketTable.value?.fetchTickets()
  refTicketTracker.value?.fetchStatusGraph()
}

const isCreateTicketDrawerVisible = ref(false)

const onUpdateTableFilter = data => {
  ticketFilters.value = {
    ...ticketFilters.value,
    ...data,
  }
}
</script>

<template>
  <section>
    <VRow class="match-height">
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <FilterComponent
          v-model:filters="ticketFilters"
          :filters-options="filterOptions"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <AnalyticsTicketTracker
          ref="refTicketTracker"
          :ticket-filters="ticketFilters"
          page="ticket-management"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>

      <VCol cols="12">
        <TicketTable
          ref="refTicketTable"
          :ticket-filters="ticketFilters"
          page="ticket-management"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
          @show-ticket="showTicket"
          @show-communication-drawer="showCommunicationDrawer"
          @show-communication-log-drawer="showCommunicationLogDrawer"
          @show-ticket-create-drawer="() => {
            isCreateTicketDrawerVisible = true
          }"
          @update:filter="onUpdateTableFilter"
        />
      </VCol>
    </VRow>

    <TicketDrawer
      v-model:isDrawerOpen="isTicketDrawerVisible"
      :ticket-id="ticketDrawerId"
      @refresh-ticket-data="refreshTicketData"
      @show-communication-drawer="showCommunicationDrawer"
    />
  </section>
</template>
